import React, { useContext } from 'react';
import store from '../../store';
import { deleteUser, deleteUser_db } from '../../constants';
// Custom Components
import ModalFooter from '../ModalFooter';
// Material components
import {
    Dialog,
    DialogContent,
    DialogTitle
} from '@material-ui/core';

export default function DeleteAccount() {
    // const classes = useStyles();
    const { state, reducers, history, modals } = useContext(store);

    const handleOpen = () => {
        reducers.handleModals('deleteAccount', modals.deleteAccount ? false : true)
    };

    const handleSubmit = () => {
        deleteUser_db(state.user.uid)
            .then(() => deleteUser(history, modals, reducers))
    }

    return (
        <Dialog open={modals.deleteAccount} onClose={handleOpen} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Delete account</DialogTitle>
            <DialogContent>
                **IMPORTANT**
            </DialogContent>
            <DialogContent>
                Please note that you need to have logged in recently to perform this action.
            </DialogContent>
            <ModalFooter
                handleSubmit={handleSubmit}
                handleOpen={handleOpen} />
        </Dialog>
    );
}